export default __webpack_public_path__ + "static/social-thumbnail-ce39d420a524dc2833b229d6a05a7596.png";